export default __webpack_public_path__ + "static/media/UP1_icon.82144a07.svg";